import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconMailQuestion } from "@tabler/icons-react";
import { VisitasATiendasDef } from "./VisitasATiendasDef";

export const VisitasATiendasIcon = IconMailQuestion;
export const VisitasATiendasHelpText = '* Visitas a Tiendas';

export class VisitasATiendas extends Entity<VisitasATiendasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new VisitasATiendasDef(), parentKeys);
        this.Form = import('./VisitasATiendasForm').then((module) => module.VisitasATiendasForm);
        this.Title = "Visitas a Tiendas";
        this.HelpText = VisitasATiendasHelpText;
        this.Icon = VisitasATiendasIcon;
    }
}